<template>
  <div class="m-layer-settings">
    <settings-header
      :with-back-button="!!path"
      @back="changePath(null)"
      :title="getPanelTitle"
    />
    <div class="m-layer-settings__container">
      <template v-if="!path">
        <r-simple-list
          :list="tabs"
          @click-handler="e => changePath(e.id)"
          :with-bg="true"
        />
      </template>
      <template v-else-if="path === 'settings' && hasInstrument('Styles')">
        <style-settings
          :id="id"
          :layer-style="layerStyle"
          :geom-type="layerGeomType"
          :style-controller="styleController"
          :layer-controller="layerController"
        />
      </template>
      <template v-else-if="path === 'filters' && hasInstrument('Filters')">
        <filters-settings
          :id="id"
          :layer-style="layerStyle"
          :layer-controller="layerController"
        />
      </template>
      <template v-else-if="path === 'diagram' && hasInstrument('Diagrams')">
        <diagram-settings
          :id="id"
          :layer-style="layerStyle"
          :geom-type="layerGeomType"
          :layer-controller="layerController"
          :diagram-controller="diagramController"
        />
      </template>
      <template v-else-if="path === 'heatmap' && hasInstrument('Heatmaps')">
        <heatmaps
          :id="id"
          :layer-style="layerStyle"
          :layer-controller="layerController"
          :heatmap-controller="heatmapController"
        />
      </template>
      <template v-else-if="path === 'matrices'">
        <matrices-control
          :id="id"
          :parent-id="layerParentId"
          :layer-style="layerStyle"
          :layer-controller="layerController"
          :matrices-controller="matricesController"
        />
      </template>
    </div>
    <settings-close-button @close="closeLayerSettings" />
  </div>
</template>

<script>
import SettingsHeader from "@/components/calculations/settings-header/settings-header";
import SettingsCloseButton from "@/components/calculations/settings-header/settings-close";
import StyleSettings from "./style/style-settings";
import FiltersSettings from "./filters/filters-settings";
import DiagramSettings from "./diagram/diagram-settings";
import Heatmaps from "./heatmaps/heatmaps";
import MatricesControl from "./matrices/matrices-control";

const tabs = [
  {
    id: "settings",
    title: "Общие настройки",
    subtitle: "Настройка цвета, обводки, размеров",
    icon: "stylize"
  },
  {
    id: "filters",
    title: "Фильтры",
    subtitle: "Настройка сортировки и фильтрации объектов",
    icon: "filter"
  }
];

export default {
  components: {
    SettingsHeader,
    SettingsCloseButton,
    StyleSettings,
    FiltersSettings,
    DiagramSettings,
    Heatmaps,
    MatricesControl
  },
  props: [
    "id",
    "style-config",
    "layer-controller",
    "style-controller",
    "diagram-controller",
    "heatmap-controller",
    "matrices-controller"
  ],
  data() {
    return {
      path: null
    };
  },
  computed: {
    sourceId() {
      return this.$store.state.profiles.sourceIdById[this.id];
    },
    layerStyle() {
      return this.styleConfig[this.id];
    },
    layerGeomType() {
      return this.$store.state.datasources[this.sourceId].geom_type;
    },
    tabs() {
      switch (this.layerGeomType) {
        case "point":
        case "multipoint":
          return [
            ...tabs,
            {
              id: "heatmap",
              title: "Тепловые карты",
              subtitle: "Построение и настройка тепловых карт",
              icon: "heatmap"
            }
          ];
        case "line_string":
        case "multi_line_string":
          return [
            ...tabs,
            {
              id: "diagram",
              title: "Эпюры",
              subtitle: "Отображение и настройка эпюр по объектам",
              icon: "epure"
            }
          ];
        case "polygon":
        case "multi_polygon":
          if (
            this.$store.state.datasources[this.sourceId].datatype === "zones"
          ) {
            return [
              ...tabs,
              {
                id: "matrices",
                title: "Матрицы корреспонденций",
                subtitle: "Построение и настройка матриц корреспонденций",
                icon: "heatmap"
              }
            ];
          }

          return [...tabs];
        default:
          return [];
      }
    },
    layerParentId() {
      return this.$store.state.datasources[this.sourceId].parent_id;
    },
    getPanelTitle() {
      switch (this.path) {
        case "settings":
          return "Общие настройки";
        case "diagram":
          return "Настройки эпюр";
        case "filters":
          return "Фильтры и сортировка";
        case "heatmap":
          return "Тепловые карты";
        default:
          return "Параметры слоя";
      }
    }
  },
  methods: {
    changePath(path) {
      this.path = path;
    },
    closeLayerSettings() {
      this.$emit("close-settings", { type: "settings", data: { id: this.id } });
    },
    hasInstrument(instrument) {
      return this.$store.getters.hasInstrument("Map", instrument);
    }
  }
};
</script>

<style lang="scss">
.m-layer-settings {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;

  &__container {
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 0px;
    padding: 8px;
    overflow: auto;
  }
}
</style>
